import { Box, FloraTypography } from '@grupoboticario/flora-react'

import * as S from './PageTitle.styles'

const PageTitle = ({ children }) => (
  <Box css={S.wrapperCss}>
    <FloraTypography as="h2" fontSize="title">
      {children}
    </FloraTypography>
  </Box>
)

export default PageTitle
